import { useTranslation } from 'react-i18next'

import { Heading } from '@ps/ds/components/primitives/Heading/Heading'
import { GROUPED_REQUEST_STATUS, REQUEST_STATUS } from 'src/api/constants/request'
import type { TrackingData } from 'src/api/domains/service-tracking/serviceTracking.types'
import type { GroupedRequestStatus } from 'src/api/types/requests'
import { NS } from 'src/constants/i18n'
import { TreatmentBucketCard } from 'src/features/treatment/components/TreatmentBucketCard'

import { TREATMENT_BUCKET, type TreatmentBucket } from './constants/treatment'
import { buildTreatmentEntries } from './utils/buildTreatmentEntries'

type TreatmentProps = {
  groupedRequestStatus: GroupedRequestStatus
  requestPests: TrackingData['requestPests']
  requestStatus: TrackingData['requestStatus']
  workOrderPestsByName: TrackingData['parsedFields']['workOrderPestsByName']
}

const TREATMENT_BUCKETS: TreatmentBucket[] = [
  TREATMENT_BUCKET.IN_PROGRESS,
  TREATMENT_BUCKET.EXCLUDED,
  TREATMENT_BUCKET.COMPLETED,
]

export const Treatment = ({
  groupedRequestStatus,
  requestPests,
  requestStatus,
  workOrderPestsByName,
}: TreatmentProps) => {
  const { t } = useTranslation(NS.TRACKING)
  const isVoided = groupedRequestStatus === GROUPED_REQUEST_STATUS.VOIDED
  const isDelayed = requestStatus.slug === REQUEST_STATUS.DELAYED
  const treatmentEntries = buildTreatmentEntries(
    requestPests,
    groupedRequestStatus,
    workOrderPestsByName,
  )

  return (
    <section className="flex flex-col gap-4" data-testid="treatment-section">
      <Heading as="h2" size="lg" weight="bold">
        {t('treatment.title')}
      </Heading>

      {TREATMENT_BUCKETS.map((bucket) => (
        <TreatmentBucketCard
          key={bucket}
          bucket={bucket}
          isDelayed={isDelayed}
          isVoided={isVoided}
          entries={treatmentEntries}
        />
      ))}
    </section>
  )
}
